import NoteItem from './NoteItem';

export default NoteItem;
